import * as React from 'react';
import ApplicationBanner, { Props } from './application_banner';
import { shallow, ShallowWrapper } from 'enzyme';
import applicationDummy from '__fixtures__/application_dummy';

const createTestProps = moreProps => {
  return {
    seenList: [],
    delivered: true,
    application: applicationDummy,
    profileUrl: '',
    moveToStep: '',
    rejectApplication: '',
    hiringSteps: [],
    currentStep: '',
    urls: [],
    stepLabel: '',
    waitingReview: true,
    onApplicationList: true,
    ...moreProps,
  };
};

let props: Props;
let wrapped: ShallowWrapper;

describe('Application Banner component', () => {
  beforeEach(() => {
    props = createTestProps({});
    wrapped = shallow(<ApplicationBanner {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});

test.todo('add more tests');
